<div class="flex justify-center mt-[32px]">
  @if (status()) {
  <svg
    width="114"
    height="122"
    viewBox="0 0 114 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M113.535 17.588C76.1589 16.8414 57.003 0.424531 57.0002 0.421814C57.0002 0.421814 37.8443 16.8414 0.465189 17.588C0.30011 36.4016 1.28243 56.0079 6.01401 74.2467C13.3393 102.484 33.4347 113.452 57.0002 121.578C80.5657 113.452 100.661 102.485 107.986 74.2467C112.718 56.0079 113.7 36.4016 113.535 17.588Z"
      fill="#C3E2FA"
    />
    <path
      d="M89.6066 82.9597H25.1009C20.1493 82.9597 16.1357 78.9462 16.1357 73.9952C16.1357 69.0442 20.1493 65.03 25.1009 65.03H89.6066C94.5576 65.03 98.5718 69.0435 98.5718 73.9952C98.5718 78.9455 94.5583 82.9597 89.6066 82.9597Z"
      fill="url(#paint0_linear_1983_50135)"
    />
    <path
      d="M34.6859 70.7358L32.3897 73.4341L32.4121 73.498L35.7898 72.818V74.964L32.3897 74.3689L32.3694 74.4327L34.6859 77.0468L32.7946 78.1514L31.5834 74.858L31.5399 74.8791L30.3083 78.1514L28.4795 77.0468L30.7546 74.3906V74.3472L27.417 74.964V72.818L30.7118 73.4762L30.7322 73.4341L28.4795 70.7562L30.3721 69.6733L31.5609 72.9246H31.6044L32.8157 69.6733L34.6859 70.7358Z"
      fill="#00B0ED"
    />
    <path
      d="M44.3394 70.7358L42.0432 73.4341L42.0657 73.498L45.4433 72.818V74.964L42.0432 74.3689L42.0222 74.4327L44.3387 77.0468L42.4474 78.1514L41.2362 74.858L41.1927 74.8791L39.9611 78.1514L38.1337 77.0468L40.4074 74.3906V74.3472L37.0698 74.964V72.818L40.3639 73.4762L40.385 73.4341L38.1337 70.7562L40.0249 69.6733L41.2138 72.9246H41.2573L42.4685 69.6733L44.3394 70.7358Z"
      fill="#00B0ED"
    />
    <path
      d="M53.9914 70.7358L51.6952 73.4341L51.7176 73.498L55.0953 72.818V74.964L51.6952 74.3689L51.6748 74.4327L53.9921 77.0468L52.1008 78.1514L50.8895 74.858L50.846 74.8791L49.6144 78.1514L47.787 77.0468L50.0607 74.3906V74.3472L46.7231 74.964V72.818L50.0179 73.4762L50.0383 73.4341L47.7877 70.7562L49.6789 69.6733L50.8678 72.9246H50.9113L52.1225 69.6733L53.9914 70.7358Z"
      fill="#00B0ED"
    />
    <path
      d="M63.6456 70.7358L61.3494 73.4341L61.3718 73.498L64.7495 72.818V74.964L61.3494 74.3689L61.3283 74.4327L63.6449 77.0468L61.7536 78.1514L60.5423 74.858L60.4989 74.8791L59.2666 78.1514L57.4378 77.0468L59.7136 74.3906V74.3472L56.376 74.964V72.818L59.6701 73.4762L59.6911 73.4341L57.4385 70.7562L59.3318 69.6733L60.5206 72.9246H60.5641L61.7753 69.6733L63.6456 70.7358Z"
      fill="#00B0ED"
    />
    <path
      d="M73.2972 70.7358L71.0011 73.4341L71.0235 73.498L74.4011 72.818V74.964L71.0011 74.3689L70.9807 74.4327L73.2972 77.0468L71.406 78.1514L70.1947 74.858L70.1512 74.8791L68.9196 78.1514L67.0922 77.0468L69.3659 74.3906V74.3472L66.0283 74.964V72.818L69.3231 73.4762L69.3435 73.4341L67.0922 70.7562L68.9834 69.6733L70.1723 72.9246H70.2157L71.427 69.6733L73.2972 70.7358Z"
      fill="#00B0ED"
    />
    <path
      d="M90.362 40.9523V40.9466H90.3075H78.9871H78.0955H73.4156H73.195H71.1868H67.6235H65.6153H61.8571H61.6503H53.1765C51.9785 35.1567 46.8399 30.7911 40.7007 30.7911C33.6761 30.7911 27.9604 36.5064 27.9604 43.5314C27.9604 43.6185 27.9655 43.705 27.9673 43.7915H33.0696C33.0664 43.7044 33.0564 43.6191 33.0564 43.5314C33.0564 39.3162 36.4857 35.8874 40.7007 35.8874C44.9157 35.8874 48.3443 39.3162 48.3443 43.5314C48.3443 43.6191 48.3343 43.7044 48.3311 43.7915H61.6503H61.8571H64.9875H65.6147H71.1862H73.4143H78.0943H78.9859H90.3608H92.9417C92.946 43.7275 92.9604 43.6661 92.9604 43.6016C92.9623 42.1541 91.8025 40.9823 90.362 40.9523Z"
      fill="#00B0ED"
    />
    <path
      d="M90.3615 43.788H78.9866H78.095H73.4151H71.187H65.6155H64.9883H61.8579H61.6511H48.3319C48.1934 47.8823 44.8281 51.1721 40.7015 51.1721C36.5742 51.1721 33.2094 47.8823 33.071 43.788H27.9688C28.1085 50.6933 33.764 56.2683 40.7021 56.2683C46.7899 56.2683 51.8909 51.9754 53.144 46.2582H61.6517H61.8585H65.6167H71.1883H71.2534H72.2935H73.417H76.825H77.8651H78.0969H78.9885H80.0687V52.1226C80.0687 53.1196 80.877 53.9285 81.8745 53.9285C82.8758 53.9285 83.6872 53.1171 83.6872 52.1157V46.2582H85.139V48.5497C85.139 49.5817 85.9755 50.4182 87.0075 50.4182C87.9737 50.4182 88.7575 49.635 88.7575 48.6681V46.2575H90.3641V46.2469C91.7388 46.2181 92.8466 45.1447 92.9449 43.7874H90.3615V43.788Z"
      fill="#00B0ED"
    />
    <circle cx="92.8854" cy="73.8875" r="9.20183" fill="white" />
    <mask
      id="mask0_1983_50135"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="80"
      y="62"
      width="24"
      height="25"
    >
      <path
        d="M92.0389 85.2064C93.4335 85.2081 94.8146 84.9343 96.103 84.4006C97.3914 83.8669 98.5617 83.0839 99.5465 82.0965C100.534 81.1117 101.317 79.9414 101.851 78.653C102.384 77.3646 102.658 75.9835 102.656 74.5889C102.658 73.1944 102.384 71.8132 101.851 70.5248C101.317 69.2364 100.534 68.0661 99.5465 67.0813C98.5617 66.0939 97.3914 65.3109 96.103 64.7772C94.8146 64.2435 93.4335 63.9697 92.0389 63.9714C90.6443 63.9697 89.2632 64.2435 87.9748 64.7772C86.6864 65.3109 85.5161 66.0939 84.5313 67.0813C83.5439 68.0661 82.7609 69.2364 82.2272 70.5248C81.6935 71.8132 81.4197 73.1944 81.4214 74.5889C81.4197 75.9835 81.6935 77.3646 82.2272 78.653C82.7609 79.9414 83.5439 81.1117 84.5313 82.0965C85.5161 83.0839 86.6864 83.8669 87.9748 84.4006C89.2632 84.9343 90.6443 85.2081 92.0389 85.2064Z"
        fill="white"
        stroke="white"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M87.792 74.5889L90.9772 77.7742L97.3477 71.4037"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_1983_50135)">
      <path
        d="M79.2979 61.8479H104.78V87.3299H79.2979V61.8479Z"
        fill="#27DF8A"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1983_50135"
        x1="16.1361"
        y1="73.9946"
        x2="98.5718"
        y2="73.9946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.9104" stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
    </defs>
  </svg>
  } @else {
  <svg
    width="114"
    height="122"
    viewBox="0 0 114 122"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M113.535 17.1662C76.1589 16.4196 57.003 0.00271735 57.0002 0C57.0002 0 37.8443 16.4196 0.465189 17.1662C0.30011 35.9797 1.28243 55.5861 6.01401 73.8249C13.3393 102.062 33.4347 113.03 57.0002 121.156C80.5657 113.03 100.661 102.063 107.986 73.8249C112.718 55.5861 113.7 35.9797 113.535 17.1662Z"
      fill="#B2D8F8"
    />
    <path
      d="M88.1594 82.543H23.6537C18.702 82.543 14.6885 78.5295 14.6885 73.5785C14.6885 68.6275 18.702 64.6133 23.6537 64.6133H88.1594C93.1104 64.6133 97.1246 68.6268 97.1246 73.5785C97.1246 78.5288 93.1111 82.543 88.1594 82.543Z"
      fill="url(#paint0_linear_1983_18265)"
    />
    <path
      d="M33.2357 70.3218L30.9395 73.0201L30.962 73.0839L34.3396 72.4039V74.55L30.9395 73.9548L30.9192 74.0187L33.2357 76.6328L31.3444 77.7374L30.1332 74.444L30.0897 74.465L28.8581 77.7374L27.0293 76.6328L29.3044 73.9766V73.9331L25.9668 74.55V72.4039L29.2616 73.0622L29.282 73.0201L27.0293 70.3421L28.9219 69.2593L30.1108 72.5106H30.1542L31.3655 69.2593L33.2357 70.3218Z"
      fill="#00B0ED"
    />
    <path
      d="M42.8882 70.3218L40.5921 73.0201L40.6145 73.0839L43.9921 72.4039V74.55L40.5921 73.9548L40.571 74.0187L42.8875 76.6328L40.9963 77.7374L39.785 74.444L39.7415 74.465L38.5099 77.7374L36.6825 76.6328L38.9562 73.9766V73.9331L35.6187 74.55V72.4039L38.9128 73.0622L38.9338 73.0201L36.6825 70.3421L38.5738 69.2593L39.7626 72.5106H39.8061L41.0173 69.2593L42.8882 70.3218Z"
      fill="#00B0ED"
    />
    <path
      d="M52.5412 70.3218L50.245 73.0201L50.2674 73.0839L53.6451 72.4039V74.55L50.245 73.9548L50.2246 74.0187L52.5419 76.6328L50.6506 77.7374L49.4393 74.444L49.3958 74.465L48.1642 77.7374L46.3368 76.6328L48.6105 73.9766V73.9331L45.2729 74.55V72.4039L48.5677 73.0622L48.5881 73.0201L46.3375 70.3421L48.2288 69.2593L49.4176 72.5106H49.4611L50.6723 69.2593L52.5412 70.3218Z"
      fill="#00B0ED"
    />
    <path
      d="M62.1944 70.3218L59.8982 73.0201L59.9206 73.0839L63.2983 72.4039V74.55L59.8982 73.9548L59.8772 74.0187L62.1937 76.6328L60.3024 77.7374L59.0912 74.444L59.0477 74.465L57.8154 77.7374L55.9866 76.6328L58.2624 73.9766V73.9331L54.9248 74.55V72.4039L58.2189 73.0622L58.24 73.0201L55.9873 70.3421L57.8806 69.2593L59.0694 72.5106H59.1129L60.3242 69.2593L62.1944 70.3218Z"
      fill="#00B0ED"
    />
    <path
      d="M71.847 70.3218L69.5509 73.0201L69.5733 73.0839L72.951 72.4039V74.55L69.5509 73.9548L69.5305 74.0187L71.847 76.6328L69.9558 77.7374L68.7445 74.444L68.701 74.465L67.4694 77.7374L65.642 76.6328L67.9157 73.9766V73.9331L64.5781 74.55V72.4039L67.8729 73.0622L67.8933 73.0201L65.642 70.3421L67.5332 69.2593L68.7221 72.5106H68.7656L69.9768 69.2593L71.847 70.3218Z"
      fill="#00B0ED"
    />
    <path
      d="M91.4133 40.5362V40.5305H91.3588H80.0384H79.1468H74.4669H74.2463H72.2381H68.6748H66.6666H62.9084H62.7016H54.2277C53.0297 34.7406 47.8912 30.375 41.7519 30.375C34.7274 30.375 29.0117 36.0903 29.0117 43.1153C29.0117 43.2024 29.0167 43.2889 29.0186 43.3754H34.1208C34.1177 43.2883 34.1077 43.203 34.1077 43.1153C34.1077 38.9001 37.537 35.4713 41.7519 35.4713C45.9669 35.4713 49.3956 38.9001 49.3956 43.1153C49.3956 43.203 49.3855 43.2883 49.3824 43.3754H62.7016H62.9084H66.0388H66.666H72.2375H74.4656H79.1455H80.0372H91.4121H93.9929C93.9973 43.3114 94.0117 43.25 94.0117 43.1855C94.0136 41.738 92.8538 40.5662 91.4133 40.5362Z"
      fill="#00B0ED"
    />
    <path
      d="M91.4128 43.372H80.0379H79.1463H74.4664H72.2383H66.6667H66.0395H62.9091H62.7024H49.3832C49.2447 47.4663 45.8794 50.756 41.7527 50.756C37.6254 50.756 34.2607 47.4663 34.1222 43.372H29.02C29.1597 50.2772 34.8152 55.8522 41.7533 55.8522C47.8412 55.8522 52.9422 51.5593 54.1953 45.8421H62.703H62.9098H66.668H72.2395H72.3047H73.3448H74.4683H77.8762H78.9163H79.1482H80.0398H81.12V51.7066C81.12 52.7035 81.9283 53.5125 82.9258 53.5125C83.9271 53.5125 84.7385 52.701 84.7385 51.6997V45.8421H86.1903V48.1336C86.1903 49.1656 87.0268 50.0022 88.0588 50.0022C89.0249 50.0022 89.8088 49.2189 89.8088 48.252V45.8415H91.4153V45.8308C92.79 45.802 93.8978 44.7286 93.9962 43.3713H91.4128V43.372Z"
      fill="#00B0ED"
    />
    <circle cx="91.4391" cy="73.4654" r="9.20183" fill="white" />
    <g clip-path="url(#clip0_1983_18265)">
      <mask
        id="mask0_1983_18265"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="78"
        y="62"
        width="25"
        height="24"
      >
        <path
          d="M90.5926 84.7843C91.9872 84.786 93.3683 84.5122 94.6567 83.9785C95.9451 83.4448 97.1154 82.6618 98.1002 81.6745C99.0876 80.6896 99.8706 79.5193 100.404 78.2309C100.938 76.9425 101.212 75.5614 101.21 74.1668C101.212 72.7723 100.938 71.3911 100.404 70.1027C99.8706 68.8143 99.0876 67.6441 98.1002 66.6592C97.1154 65.6718 95.9451 64.8888 94.6567 64.3551C93.3683 63.8215 91.9872 63.5476 90.5926 63.5493C89.198 63.5476 87.8169 63.8215 86.5285 64.3551C85.2401 64.8888 84.0698 65.6718 83.085 66.6592C82.0976 67.6441 81.3146 68.8143 80.7809 70.1027C80.2472 71.3911 79.9734 72.7723 79.9751 74.1668C79.9734 75.5614 80.2472 76.9425 80.7809 78.2309C81.3146 79.5193 82.0976 80.6896 83.085 81.6745C84.0698 82.6618 85.2401 83.4448 86.5285 83.9785C87.8169 84.5122 89.198 84.786 90.5926 84.7843Z"
          fill="white"
          stroke="white"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M86.3457 74.1668L89.531 77.3521L95.9015 70.9816"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1983_18265)">
        <path
          d="M77.8516 61.4258H103.334V86.9078H77.8516V61.4258Z"
          fill="#27DF8A"
        />
      </g>
      <circle cx="90.5924" cy="74.0051" r="9.55575" fill="white" />
      <path
        d="M90.5926 61.6C91.7621 61.6 92.8903 61.7493 93.9769 62.0479C95.0635 62.3465 96.0755 62.7779 97.0128 63.3419C97.9502 63.906 98.8087 64.5696 99.5884 65.3327C100.368 66.0958 101.036 66.9543 101.592 67.9083C102.147 68.8622 102.575 69.8783 102.873 70.9566C103.172 72.035 103.325 73.1631 103.334 74.341C103.334 75.5106 103.184 76.6387 102.886 77.7253C102.587 78.8119 102.156 79.8239 101.592 80.7612C101.028 81.6986 100.364 82.5571 99.6008 83.3368C98.8377 84.1165 97.9792 84.7843 97.0253 85.34C96.0714 85.8958 95.0552 86.323 93.9769 86.6216C92.8986 86.9202 91.7704 87.0737 90.5926 87.082C89.423 87.082 88.2949 86.9327 87.2082 86.634C86.1216 86.3354 85.1096 85.9041 84.1723 85.34C83.235 84.776 82.3764 84.1124 81.5967 83.3493C80.817 82.5861 80.1493 81.7276 79.5935 80.7737C79.0377 79.8198 78.6105 78.8036 78.3119 77.7253C78.0133 76.647 77.8599 75.5189 77.8516 74.341C77.8516 73.1714 78.0009 72.0433 78.2995 70.9566C78.5981 69.87 79.0294 68.858 79.5935 67.9207C80.1576 66.9834 80.8211 66.1249 81.5843 65.3451C82.3474 64.5654 83.2059 63.8977 84.1599 63.3419C85.1138 62.7861 86.1299 62.359 87.2082 62.0603C88.2866 61.7617 89.4147 61.6083 90.5926 61.6ZM91.9986 74.341L96.2538 70.0857L94.8479 68.6797L90.5926 72.935L86.3373 68.6797L84.9313 70.0857L89.1866 74.341L84.9313 78.5963L86.3373 80.0023L90.5926 75.747L94.8479 80.0023L96.2538 78.5963L91.9986 74.341Z"
        fill="#FF6174"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1983_18265"
        x1="14.6889"
        y1="73.5779"
        x2="97.1246"
        y2="73.5779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.9104" stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <clipPath id="clip0_1983_18265">
        <rect
          width="25.482"
          height="25.482"
          fill="white"
          transform="translate(77.8516 61.4258)"
        />
      </clipPath>
    </defs>
  </svg>

  }
</div>
<p class="mt-[16px] text-center font-inter font-bold text-base xlplus:text-lg">
  @if (!invalidToken() && status()) { Password Reset Successful } @else if
  (invalidToken() && !status()) { Link Expired or Invalid } @else { Password
  Reset Failed }
</p>
<p
  class="mt-[4px] font-lato font-normal text-center text-sm xlplus:text-base text-taxpod-gray-light"
>
  @if (!invalidToken() && status()) { Your password has been successfully
  reset.<br />
  You can now log in with your new password. } @else if (invalidToken() &&
  !status()) { The password reset attempt was unsuccessful.<br />
  This may be due to an expired or invalid link. } @else { We couldn’t reset
  your password. Please try <br />
  again. If the problem persists, please contact the <br />
  administrators for further assistance. }
</p>

<p
  class="flex justify-center items-center gap-2 mt-[28px] mb-[12px] font-lato font-bold text-center text-sm xlplus:text-base cursor-pointer text-taxpod-blue"
  routerLink="/auth/login"
>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04754 13.0623L7.35387 13.774C7.06015 14.0753 6.5852 14.0753 6.29461 13.774L0.220288 7.545C-0.0734293 7.24365 -0.0734293 6.75636 0.220288 6.45821L6.29461 0.226013C6.58833 -0.0753378 7.06327 -0.0753378 7.35387 0.226013L8.04754 0.937715C8.34438 1.24227 8.33813 1.73918 8.03504 2.03733L4.26984 5.71766H13.2501C13.6657 5.71766 14 6.06068 14 6.48706V7.51294C14 7.93932 13.6657 8.28235 13.2501 8.28235H4.26984L8.03504 11.9627C8.34126 12.2608 8.34751 12.7577 8.04754 13.0623Z"
      fill="#00B0ED"
    />
  </svg>
  Back to Login
</p>
